<template>
    <div class="form-group formly-input"
         :class="[ to.inputType, to.wrapperClasses, {'formly-has-value': model[field.key], 'formly-has-focus': form[field.key].$active, 'has-error has-danger': hasError}]">
        <label v-if="to.label" :for="to.id ? to.id : null">{{to.label}}</label>
        <masked-input v-model="model[field.key]" @input="onChange()"
                      :mask="mask" :placeholder-char="placeholderChar" class="form-control" :class="to.classes"
                      :id="to.id ? to.id : null" type="text" />
        <error-display :form="form" :field="field.key"></error-display>
    </div>
</template>

<script>
    import baseField from 'vue-formly-bootstrap/src/fields/baseField'

    export default {
        mixins: [baseField],
        props: ['form', 'field', 'model', 'to'],
        name: 'maskedInputField',
        data () {
            return {}
        },
        created (e) {
//            console.log(this.model[this.field.key])
//            this.model[this.maskedValueKey] = this.model[this.field.key]
//            console.log(this.model[this.maskedValueKey])
        },
        computed: {
//            maskedModel: {
//                get: function () {
//                    return this.model[this.field.key]
//                },
//                set: function (newValue) {
//                    this.model[this.field.key] = newValue
//                    this.$set(this.form[this.field.key], '$dirty', true)
//                }
//            },
//            maskedValueKey: function () {
//                let keyArray = this.field.key.split('.')
//                keyArray.splice(keyArray.length - 1, 0, 'maskedValues')
//                return keyArray.join('.')
//            },
            mask: function () {
                return this.to.mask !== undefined ? this.to.mask : null
            },
            placeholderChar: function () {
                return this.to.placeholderChar !== undefined ? this.to.placeholderChar : '_'
            }
        },
        methods: {
            onChange () {
                this.$set(this.form[this.field.key], '$dirty', true)
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// MaskedInputField.vue?e87ca516